// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/signup_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { AccountStub, Advisor, EntityMetadata, FamilyStub } from "./common_pb.ts";
import { AssignmentOpportunity, AssignmentRequest } from "./assignments_pb.ts";

/**
 * @generated from message protogen.SignupStateChoiceValue
 */
export class SignupStateChoiceValue extends Message<SignupStateChoiceValue> {
  /**
   * @generated from field: bool value = 1;
   */
  value = false;

  /**
   * @generated from field: string valueString = 2;
   */
  valueString = "";

  constructor(data?: PartialMessage<SignupStateChoiceValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SignupStateChoiceValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "valueString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupStateChoiceValue {
    return new SignupStateChoiceValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupStateChoiceValue {
    return new SignupStateChoiceValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupStateChoiceValue {
    return new SignupStateChoiceValue().fromJsonString(jsonString, options);
  }

  static equals(a: SignupStateChoiceValue | PlainMessage<SignupStateChoiceValue> | undefined, b: SignupStateChoiceValue | PlainMessage<SignupStateChoiceValue> | undefined): boolean {
    return proto3.util.equals(SignupStateChoiceValue, a, b);
  }
}

/**
 * @generated from message protogen.Payment
 */
export class Payment extends Message<Payment> {
  /**
   * @generated from field: string paymentMethodId = 1;
   */
  paymentMethodId = "";

  /**
   * @generated from field: string customerId = 2;
   */
  customerId = "";

  /**
   * @generated from field: string promoCode = 3;
   */
  promoCode = "";

  /**
   * @generated from field: string couponId = 4;
   */
  couponId = "";

  constructor(data?: PartialMessage<Payment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.Payment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "paymentMethodId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customerId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "promoCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "couponId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Payment {
    return new Payment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Payment {
    return new Payment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Payment {
    return new Payment().fromJsonString(jsonString, options);
  }

  static equals(a: Payment | PlainMessage<Payment> | undefined, b: Payment | PlainMessage<Payment> | undefined): boolean {
    return proto3.util.equals(Payment, a, b);
  }
}

/**
 * @generated from message protogen.Membership
 */
export class Membership extends Message<Membership> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: int32 supportHours = 2;
   */
  supportHours = 0;

  /**
   * @generated from field: int32 maxUsers = 3;
   */
  maxUsers = 0;

  /**
   * @generated from field: int32 amountCents = 4;
   */
  amountCents = 0;

  /**
   * @generated from field: repeated string additionalFeatures = 5;
   */
  additionalFeatures: string[] = [];

  constructor(data?: PartialMessage<Membership>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.Membership";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "supportHours", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "maxUsers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "amountCents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "additionalFeatures", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Membership {
    return new Membership().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Membership {
    return new Membership().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Membership {
    return new Membership().fromJsonString(jsonString, options);
  }

  static equals(a: Membership | PlainMessage<Membership> | undefined, b: Membership | PlainMessage<Membership> | undefined): boolean {
    return proto3.util.equals(Membership, a, b);
  }
}

/**
 * @generated from message protogen.UserInfo
 */
export class UserInfo extends Message<UserInfo> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string firstName = 2;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 3;
   */
  lastName = "";

  /**
   * @generated from field: string phone = 4;
   */
  phone = "";

  /**
   * @generated from field: string address = 5;
   */
  address = "";

  /**
   * @generated from field: string timezone = 6;
   */
  timezone = "";

  constructor(data?: PartialMessage<UserInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UserInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInfo {
    return new UserInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInfo {
    return new UserInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInfo {
    return new UserInfo().fromJsonString(jsonString, options);
  }

  static equals(a: UserInfo | PlainMessage<UserInfo> | undefined, b: UserInfo | PlainMessage<UserInfo> | undefined): boolean {
    return proto3.util.equals(UserInfo, a, b);
  }
}

/**
 * @generated from message protogen.PartnerInfo
 */
export class PartnerInfo extends Message<PartnerInfo> {
  /**
   * @generated from field: string firstName = 1;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 2;
   */
  lastName = "";

  /**
   * @generated from field: string email = 3;
   */
  email = "";

  /**
   * @generated from field: string phone = 4;
   */
  phone = "";

  constructor(data?: PartialMessage<PartnerInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.PartnerInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PartnerInfo {
    return new PartnerInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PartnerInfo {
    return new PartnerInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PartnerInfo {
    return new PartnerInfo().fromJsonString(jsonString, options);
  }

  static equals(a: PartnerInfo | PlainMessage<PartnerInfo> | undefined, b: PartnerInfo | PlainMessage<PartnerInfo> | undefined): boolean {
    return proto3.util.equals(PartnerInfo, a, b);
  }
}

/**
 * Consider merging with UserInfo.
 *
 * @generated from message protogen.SignupConsultationDetails
 */
export class SignupConsultationDetails extends Message<SignupConsultationDetails> {
  /**
   * @generated from field: string firstName = 1;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 2;
   */
  lastName = "";

  /**
   * @generated from field: string email = 3;
   */
  email = "";

  /**
   * @generated from field: string phone = 4;
   */
  phone = "";

  /**
   * @generated from field: string zipCode = 5;
   */
  zipCode = "";

  /**
   * Inferred from zip code.
   *
   * @generated from field: string city = 6;
   */
  city = "";

  /**
   * @generated from field: string state = 7;
   */
  state = "";

  constructor(data?: PartialMessage<SignupConsultationDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SignupConsultationDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "zipCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupConsultationDetails {
    return new SignupConsultationDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupConsultationDetails {
    return new SignupConsultationDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupConsultationDetails {
    return new SignupConsultationDetails().fromJsonString(jsonString, options);
  }

  static equals(a: SignupConsultationDetails | PlainMessage<SignupConsultationDetails> | undefined, b: SignupConsultationDetails | PlainMessage<SignupConsultationDetails> | undefined): boolean {
    return proto3.util.equals(SignupConsultationDetails, a, b);
  }
}

/**
 * @generated from message protogen.SignupState
 */
export class SignupState extends Message<SignupState> {
  /**
   * @generated from field: string stepName = 1;
   */
  stepName = "";

  /**
   * @generated from field: map<string, protogen.SignupStateChoiceValue> goals = 2;
   */
  goals: { [key: string]: SignupStateChoiceValue } = {};

  /**
   * @generated from field: map<string, protogen.SignupStateChoiceValue> household = 3;
   */
  household: { [key: string]: SignupStateChoiceValue } = {};

  /**
   * @generated from field: map<string, protogen.SignupStateChoiceValue> superpowers = 4;
   */
  superpowers: { [key: string]: SignupStateChoiceValue } = {};

  /**
   * @generated from field: protogen.Payment payment = 5;
   */
  payment?: Payment;

  /**
   * @generated from field: string consultationEventUri = 6;
   */
  consultationEventUri = "";

  /**
   * @generated from field: string consultationInviteeUri = 7;
   */
  consultationInviteeUri = "";

  /**
   * @generated from field: int64 consultationEventStartSec = 8;
   */
  consultationEventStartSec = protoInt64.zero;

  /**
   * @generated from field: string consultationEventHost = 9;
   */
  consultationEventHost = "";

  /**
   * @generated from field: protogen.Membership membership = 10;
   */
  membership?: Membership;

  /**
   * @generated from field: protogen.UserInfo userInfo = 11;
   */
  userInfo?: UserInfo;

  /**
   * @generated from field: protogen.SignupConsultationDetails consultationDetails = 12;
   */
  consultationDetails?: SignupConsultationDetails;

  /**
   * @generated from field: string familyInfo = 13;
   */
  familyInfo = "";

  /**
   * @generated from field: map<string, protogen.SignupStateChoiceValue> fun = 14;
   */
  fun: { [key: string]: SignupStateChoiceValue } = {};

  /**
   * @generated from field: map<string, protogen.SignupStateChoiceValue> lifeEvents = 15;
   */
  lifeEvents: { [key: string]: SignupStateChoiceValue } = {};

  /**
   * @generated from field: repeated string initialTasks = 16;
   */
  initialTasks: string[] = [];

  /**
   * @generated from field: string anythingElse = 17;
   */
  anythingElse = "";

  /**
   * @generated from field: string referralSource = 18;
   */
  referralSource = "";

  /**
   * @generated from field: string referralCode = 19;
   */
  referralCode = "";

  /**
   * @generated from field: int32 termsOfServiceVersion = 20;
   */
  termsOfServiceVersion = 0;

  /**
   * @generated from field: protogen.PartnerInfo partnerInfo = 21;
   */
  partnerInfo?: PartnerInfo;

  constructor(data?: PartialMessage<SignupState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SignupState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stepName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goals", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SignupStateChoiceValue} },
    { no: 3, name: "household", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SignupStateChoiceValue} },
    { no: 4, name: "superpowers", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SignupStateChoiceValue} },
    { no: 5, name: "payment", kind: "message", T: Payment },
    { no: 6, name: "consultationEventUri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "consultationInviteeUri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "consultationEventStartSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "consultationEventHost", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "membership", kind: "message", T: Membership },
    { no: 11, name: "userInfo", kind: "message", T: UserInfo },
    { no: 12, name: "consultationDetails", kind: "message", T: SignupConsultationDetails },
    { no: 13, name: "familyInfo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "fun", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SignupStateChoiceValue} },
    { no: 15, name: "lifeEvents", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SignupStateChoiceValue} },
    { no: 16, name: "initialTasks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "anythingElse", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "referralSource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "referralCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "termsOfServiceVersion", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "partnerInfo", kind: "message", T: PartnerInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupState {
    return new SignupState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupState {
    return new SignupState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupState {
    return new SignupState().fromJsonString(jsonString, options);
  }

  static equals(a: SignupState | PlainMessage<SignupState> | undefined, b: SignupState | PlainMessage<SignupState> | undefined): boolean {
    return proto3.util.equals(SignupState, a, b);
  }
}

/**
 * @generated from message protogen.AssignmentCandidate
 */
export class AssignmentCandidate extends Message<AssignmentCandidate> {
  /**
   * @generated from field: protogen.Advisor advisor = 1;
   */
  advisor?: Advisor;

  /**
   * @generated from field: float distanceMiles = 2;
   */
  distanceMiles = 0;

  /**
   * @generated from field: string superPowers = 3;
   */
  superPowers = "";

  /**
   * @generated from field: string mmForm = 4;
   */
  mmForm = "";

  /**
   * @generated from field: int32 deactivatedFamiliesCount = 5;
   */
  deactivatedFamiliesCount = 0;

  /**
   * @generated from field: repeated string warnings = 6;
   */
  warnings: string[] = [];

  /**
   * @generated from field: int32 pendingActivationFamiliesCount = 7;
   */
  pendingActivationFamiliesCount = 0;

  constructor(data?: PartialMessage<AssignmentCandidate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AssignmentCandidate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisor", kind: "message", T: Advisor },
    { no: 2, name: "distanceMiles", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "superPowers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mmForm", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "deactivatedFamiliesCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "warnings", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "pendingActivationFamiliesCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssignmentCandidate {
    return new AssignmentCandidate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssignmentCandidate {
    return new AssignmentCandidate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssignmentCandidate {
    return new AssignmentCandidate().fromJsonString(jsonString, options);
  }

  static equals(a: AssignmentCandidate | PlainMessage<AssignmentCandidate> | undefined, b: AssignmentCandidate | PlainMessage<AssignmentCandidate> | undefined): boolean {
    return proto3.util.equals(AssignmentCandidate, a, b);
  }
}

/**
 * @generated from message protogen.GetOrCreateSessionRequest
 */
export class GetOrCreateSessionRequest extends Message<GetOrCreateSessionRequest> {
  /**
   * @generated from field: map<string, string> trackingParameters = 1;
   */
  trackingParameters: { [key: string]: string } = {};

  /**
   * @generated from field: string token = 2;
   */
  token = "";

  /**
   * @generated from field: bool isLandingPage = 3;
   */
  isLandingPage = false;

  /**
   * @generated from field: bool isSignupFlow = 4;
   */
  isSignupFlow = false;

  constructor(data?: PartialMessage<GetOrCreateSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetOrCreateSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "trackingParameters", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "isLandingPage", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "isSignupFlow", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrCreateSessionRequest {
    return new GetOrCreateSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrCreateSessionRequest {
    return new GetOrCreateSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrCreateSessionRequest {
    return new GetOrCreateSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrCreateSessionRequest | PlainMessage<GetOrCreateSessionRequest> | undefined, b: GetOrCreateSessionRequest | PlainMessage<GetOrCreateSessionRequest> | undefined): boolean {
    return proto3.util.equals(GetOrCreateSessionRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetOrCreateSessionResponse
 */
export class GetOrCreateSessionResponse extends Message<GetOrCreateSessionResponse> {
  /**
   * @generated from field: protogen.SignupState state = 1;
   */
  state?: SignupState;

  constructor(data?: PartialMessage<GetOrCreateSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetOrCreateSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "message", T: SignupState },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrCreateSessionResponse {
    return new GetOrCreateSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrCreateSessionResponse {
    return new GetOrCreateSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrCreateSessionResponse {
    return new GetOrCreateSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrCreateSessionResponse | PlainMessage<GetOrCreateSessionResponse> | undefined, b: GetOrCreateSessionResponse | PlainMessage<GetOrCreateSessionResponse> | undefined): boolean {
    return proto3.util.equals(GetOrCreateSessionResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetSignupSessionForMemberRequest
 */
export class GetSignupSessionForMemberRequest extends Message<GetSignupSessionForMemberRequest> {
  constructor(data?: PartialMessage<GetSignupSessionForMemberRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSignupSessionForMemberRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSignupSessionForMemberRequest {
    return new GetSignupSessionForMemberRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSignupSessionForMemberRequest {
    return new GetSignupSessionForMemberRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSignupSessionForMemberRequest {
    return new GetSignupSessionForMemberRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSignupSessionForMemberRequest | PlainMessage<GetSignupSessionForMemberRequest> | undefined, b: GetSignupSessionForMemberRequest | PlainMessage<GetSignupSessionForMemberRequest> | undefined): boolean {
    return proto3.util.equals(GetSignupSessionForMemberRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetSignupSessionForMemberResponse
 */
export class GetSignupSessionForMemberResponse extends Message<GetSignupSessionForMemberResponse> {
  /**
   * @generated from field: protogen.SignupState state = 1;
   */
  state?: SignupState;

  constructor(data?: PartialMessage<GetSignupSessionForMemberResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSignupSessionForMemberResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "message", T: SignupState },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSignupSessionForMemberResponse {
    return new GetSignupSessionForMemberResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSignupSessionForMemberResponse {
    return new GetSignupSessionForMemberResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSignupSessionForMemberResponse {
    return new GetSignupSessionForMemberResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSignupSessionForMemberResponse | PlainMessage<GetSignupSessionForMemberResponse> | undefined, b: GetSignupSessionForMemberResponse | PlainMessage<GetSignupSessionForMemberResponse> | undefined): boolean {
    return proto3.util.equals(GetSignupSessionForMemberResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateSessionRequest
 */
export class UpdateSessionRequest extends Message<UpdateSessionRequest> {
  /**
   * @generated from field: string updatedStepName = 1;
   */
  updatedStepName = "";

  /**
   * Fields.
   *
   * @generated from field: protogen.SignupState updatedState = 2;
   */
  updatedState?: SignupState;

  /**
   * @generated from field: bool shouldUpdateGoals = 3;
   */
  shouldUpdateGoals = false;

  /**
   * @generated from field: bool shouldUpdateHousehold = 4;
   */
  shouldUpdateHousehold = false;

  /**
   * @generated from field: bool shouldUpdateSuperpowers = 5;
   */
  shouldUpdateSuperpowers = false;

  /**
   * @generated from field: bool shouldUpdatePayment = 6;
   */
  shouldUpdatePayment = false;

  /**
   * @generated from field: bool shouldUpdateMembership = 7;
   */
  shouldUpdateMembership = false;

  /**
   * @generated from field: bool shouldUpdateUserInfo = 8;
   */
  shouldUpdateUserInfo = false;

  /**
   * @generated from field: bool shouldUpdateConsultationDetails = 9;
   */
  shouldUpdateConsultationDetails = false;

  /**
   * @generated from field: bool shouldUpdateConsultation = 10;
   */
  shouldUpdateConsultation = false;

  /**
   * @generated from field: bool shouldUpdateFamilyInfo = 11;
   */
  shouldUpdateFamilyInfo = false;

  /**
   * @generated from field: bool shouldUpdateFun = 12;
   */
  shouldUpdateFun = false;

  /**
   * @generated from field: bool shouldUpdateLifeEvents = 13;
   */
  shouldUpdateLifeEvents = false;

  /**
   * @generated from field: bool shouldUpdateInitialTasks = 14;
   */
  shouldUpdateInitialTasks = false;

  /**
   * @generated from field: bool shouldUpdateAnythingElse = 15;
   */
  shouldUpdateAnythingElse = false;

  /**
   * @generated from field: bool shouldUpdateReferralSource = 16;
   */
  shouldUpdateReferralSource = false;

  /**
   * @generated from field: bool shouldUpdateTermsOfService = 17;
   */
  shouldUpdateTermsOfService = false;

  /**
   * @generated from field: bool shouldUpdatePartnerInfo = 18;
   */
  shouldUpdatePartnerInfo = false;

  constructor(data?: PartialMessage<UpdateSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "updatedStepName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedState", kind: "message", T: SignupState },
    { no: 3, name: "shouldUpdateGoals", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "shouldUpdateHousehold", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "shouldUpdateSuperpowers", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "shouldUpdatePayment", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "shouldUpdateMembership", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "shouldUpdateUserInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "shouldUpdateConsultationDetails", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "shouldUpdateConsultation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "shouldUpdateFamilyInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "shouldUpdateFun", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "shouldUpdateLifeEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "shouldUpdateInitialTasks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "shouldUpdateAnythingElse", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "shouldUpdateReferralSource", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "shouldUpdateTermsOfService", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "shouldUpdatePartnerInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSessionRequest {
    return new UpdateSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSessionRequest {
    return new UpdateSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSessionRequest {
    return new UpdateSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSessionRequest | PlainMessage<UpdateSessionRequest> | undefined, b: UpdateSessionRequest | PlainMessage<UpdateSessionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSessionRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateSessionResponse
 */
export class UpdateSessionResponse extends Message<UpdateSessionResponse> {
  /**
   * @generated from field: protogen.SignupState state = 1;
   */
  state?: SignupState;

  /**
   * @generated from field: string token = 2;
   */
  token = "";

  constructor(data?: PartialMessage<UpdateSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "message", T: SignupState },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSessionResponse {
    return new UpdateSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSessionResponse {
    return new UpdateSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSessionResponse {
    return new UpdateSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSessionResponse | PlainMessage<UpdateSessionResponse> | undefined, b: UpdateSessionResponse | PlainMessage<UpdateSessionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSessionResponse, a, b);
  }
}

/**
 * @generated from message protogen.SignupSubmissionRequest
 */
export class SignupSubmissionRequest extends Message<SignupSubmissionRequest> {
  /**
   * @generated from field: string submissionState = 1;
   */
  submissionState = "";

  constructor(data?: PartialMessage<SignupSubmissionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SignupSubmissionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submissionState", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupSubmissionRequest {
    return new SignupSubmissionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupSubmissionRequest {
    return new SignupSubmissionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupSubmissionRequest {
    return new SignupSubmissionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignupSubmissionRequest | PlainMessage<SignupSubmissionRequest> | undefined, b: SignupSubmissionRequest | PlainMessage<SignupSubmissionRequest> | undefined): boolean {
    return proto3.util.equals(SignupSubmissionRequest, a, b);
  }
}

/**
 * @generated from message protogen.SignupSubmissionResponse
 */
export class SignupSubmissionResponse extends Message<SignupSubmissionResponse> {
  /**
   * @generated from field: protogen.SignupState state = 1;
   */
  state?: SignupState;

  constructor(data?: PartialMessage<SignupSubmissionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SignupSubmissionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "message", T: SignupState },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupSubmissionResponse {
    return new SignupSubmissionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupSubmissionResponse {
    return new SignupSubmissionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupSubmissionResponse {
    return new SignupSubmissionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignupSubmissionResponse | PlainMessage<SignupSubmissionResponse> | undefined, b: SignupSubmissionResponse | PlainMessage<SignupSubmissionResponse> | undefined): boolean {
    return proto3.util.equals(SignupSubmissionResponse, a, b);
  }
}

/**
 * @generated from message protogen.SignupSubmission
 */
export class SignupSubmission extends Message<SignupSubmission> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: protogen.SignupState state = 2;
   */
  state?: SignupState;

  /**
   * @generated from field: protogen.FamilyStub family = 3;
   */
  family?: FamilyStub;

  /**
   * @generated from field: string pipelineStatus = 4;
   */
  pipelineStatus = "";

  /**
   * @generated from field: protogen.EntityMetadata metadata = 5;
   */
  metadata?: EntityMetadata;

  /**
   * @generated from field: map<string, string> trackingParameters = 6;
   */
  trackingParameters: { [key: string]: string } = {};

  /**
   * @generated from field: int64 completionSec = 7;
   */
  completionSec = protoInt64.zero;

  /**
   * @generated from field: string blurb = 8;
   */
  blurb = "";

  /**
   * @generated from field: repeated protogen.AssignmentRequest assignments = 9;
   */
  assignments: AssignmentRequest[] = [];

  /**
   * @generated from field: int64 lastActivitySec = 10;
   */
  lastActivitySec = protoInt64.zero;

  /**
   * @generated from field: protogen.AccountStub referredBy = 11;
   */
  referredBy?: AccountStub;

  /**
   * @generated from field: string referralType = 12;
   */
  referralType = "";

  constructor(data?: PartialMessage<SignupSubmission>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SignupSubmission";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "message", T: SignupState },
    { no: 3, name: "family", kind: "message", T: FamilyStub },
    { no: 4, name: "pipelineStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "metadata", kind: "message", T: EntityMetadata },
    { no: 6, name: "trackingParameters", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "completionSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "blurb", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "assignments", kind: "message", T: AssignmentRequest, repeated: true },
    { no: 10, name: "lastActivitySec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "referredBy", kind: "message", T: AccountStub },
    { no: 12, name: "referralType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupSubmission {
    return new SignupSubmission().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupSubmission {
    return new SignupSubmission().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupSubmission {
    return new SignupSubmission().fromJsonString(jsonString, options);
  }

  static equals(a: SignupSubmission | PlainMessage<SignupSubmission> | undefined, b: SignupSubmission | PlainMessage<SignupSubmission> | undefined): boolean {
    return proto3.util.equals(SignupSubmission, a, b);
  }
}

/**
 * @generated from message protogen.ListSubmissionsRequest
 */
export class ListSubmissionsRequest extends Message<ListSubmissionsRequest> {
  /**
   * @generated from field: repeated string submissionStates = 1;
   */
  submissionStates: string[] = [];

  /**
   * @generated from field: repeated string submissionRefs = 2;
   */
  submissionRefs: string[] = [];

  /**
   * @generated from field: protogen.ListSubmissionsRequest.ListSubmissionsFilter filter = 3;
   */
  filter = ListSubmissionsRequest_ListSubmissionsFilter.UNKNOWN;

  /**
   * @generated from field: bool includeAssignments = 4;
   */
  includeAssignments = false;

  constructor(data?: PartialMessage<ListSubmissionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListSubmissionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submissionStates", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "submissionRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "filter", kind: "enum", T: proto3.getEnumType(ListSubmissionsRequest_ListSubmissionsFilter) },
    { no: 4, name: "includeAssignments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubmissionsRequest {
    return new ListSubmissionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubmissionsRequest {
    return new ListSubmissionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubmissionsRequest {
    return new ListSubmissionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubmissionsRequest | PlainMessage<ListSubmissionsRequest> | undefined, b: ListSubmissionsRequest | PlainMessage<ListSubmissionsRequest> | undefined): boolean {
    return proto3.util.equals(ListSubmissionsRequest, a, b);
  }
}

/**
 * @generated from enum protogen.ListSubmissionsRequest.ListSubmissionsFilter
 */
export enum ListSubmissionsRequest_ListSubmissionsFilter {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: AWAITING_ACTION = 1;
   */
  AWAITING_ACTION = 1,

  /**
   * @generated from enum value: DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: CONVERTED = 3;
   */
  CONVERTED = 3,

  /**
   * @generated from enum value: ALL = 4;
   */
  ALL = 4,

  /**
   * @generated from enum value: UPCOMING_CONSULTATION = 5;
   */
  UPCOMING_CONSULTATION = 5,

  /**
   * @generated from enum value: MAYBE_LATER = 6;
   */
  MAYBE_LATER = 6,

  /**
   * @generated from enum value: ACCOUNT_CREATION_COMPLETE = 7;
   */
  ACCOUNT_CREATION_COMPLETE = 7,

  /**
   * @generated from enum value: UNPAID = 8;
   */
  UNPAID = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(ListSubmissionsRequest_ListSubmissionsFilter)
proto3.util.setEnumType(ListSubmissionsRequest_ListSubmissionsFilter, "protogen.ListSubmissionsRequest.ListSubmissionsFilter", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "AWAITING_ACTION" },
  { no: 2, name: "DECLINED" },
  { no: 3, name: "CONVERTED" },
  { no: 4, name: "ALL" },
  { no: 5, name: "UPCOMING_CONSULTATION" },
  { no: 6, name: "MAYBE_LATER" },
  { no: 7, name: "ACCOUNT_CREATION_COMPLETE" },
  { no: 8, name: "UNPAID" },
]);

/**
 * @generated from message protogen.ListSubmissionsResponse
 */
export class ListSubmissionsResponse extends Message<ListSubmissionsResponse> {
  /**
   * @generated from field: repeated protogen.SignupSubmission submissions = 1;
   */
  submissions: SignupSubmission[] = [];

  constructor(data?: PartialMessage<ListSubmissionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListSubmissionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submissions", kind: "message", T: SignupSubmission, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubmissionsResponse {
    return new ListSubmissionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubmissionsResponse {
    return new ListSubmissionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubmissionsResponse {
    return new ListSubmissionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubmissionsResponse | PlainMessage<ListSubmissionsResponse> | undefined, b: ListSubmissionsResponse | PlainMessage<ListSubmissionsResponse> | undefined): boolean {
    return proto3.util.equals(ListSubmissionsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetSubmissionRequest
 */
export class GetSubmissionRequest extends Message<GetSubmissionRequest> {
  /**
   * @generated from field: string submissionRef = 1;
   */
  submissionRef = "";

  constructor(data?: PartialMessage<GetSubmissionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSubmissionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submissionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSubmissionRequest {
    return new GetSubmissionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSubmissionRequest {
    return new GetSubmissionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSubmissionRequest {
    return new GetSubmissionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSubmissionRequest | PlainMessage<GetSubmissionRequest> | undefined, b: GetSubmissionRequest | PlainMessage<GetSubmissionRequest> | undefined): boolean {
    return proto3.util.equals(GetSubmissionRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetSubmissionResponse
 */
export class GetSubmissionResponse extends Message<GetSubmissionResponse> {
  /**
   * @generated from field: protogen.SignupSubmission submission = 1;
   */
  submission?: SignupSubmission;

  constructor(data?: PartialMessage<GetSubmissionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSubmissionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submission", kind: "message", T: SignupSubmission },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSubmissionResponse {
    return new GetSubmissionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSubmissionResponse {
    return new GetSubmissionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSubmissionResponse {
    return new GetSubmissionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSubmissionResponse | PlainMessage<GetSubmissionResponse> | undefined, b: GetSubmissionResponse | PlainMessage<GetSubmissionResponse> | undefined): boolean {
    return proto3.util.equals(GetSubmissionResponse, a, b);
  }
}

/**
 * @generated from message protogen.SendAssignmentOpportunitiesRequest
 */
export class SendAssignmentOpportunitiesRequest extends Message<SendAssignmentOpportunitiesRequest> {
  /**
   * @generated from field: string entityType = 1;
   */
  entityType = "";

  /**
   * @generated from field: string entityRef = 2;
   */
  entityRef = "";

  /**
   * @generated from field: repeated string advisorRefs = 3;
   */
  advisorRefs: string[] = [];

  /**
   * @generated from field: bool appendToExisting = 4;
   */
  appendToExisting = false;

  constructor(data?: PartialMessage<SendAssignmentOpportunitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAssignmentOpportunitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "advisorRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "appendToExisting", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAssignmentOpportunitiesRequest {
    return new SendAssignmentOpportunitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAssignmentOpportunitiesRequest {
    return new SendAssignmentOpportunitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAssignmentOpportunitiesRequest {
    return new SendAssignmentOpportunitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendAssignmentOpportunitiesRequest | PlainMessage<SendAssignmentOpportunitiesRequest> | undefined, b: SendAssignmentOpportunitiesRequest | PlainMessage<SendAssignmentOpportunitiesRequest> | undefined): boolean {
    return proto3.util.equals(SendAssignmentOpportunitiesRequest, a, b);
  }
}

/**
 * @generated from message protogen.SendAssignmentOpportunitiesResponse
 */
export class SendAssignmentOpportunitiesResponse extends Message<SendAssignmentOpportunitiesResponse> {
  /**
   * @generated from field: protogen.SignupSubmission submission = 1;
   */
  submission?: SignupSubmission;

  constructor(data?: PartialMessage<SendAssignmentOpportunitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SendAssignmentOpportunitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submission", kind: "message", T: SignupSubmission },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendAssignmentOpportunitiesResponse {
    return new SendAssignmentOpportunitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendAssignmentOpportunitiesResponse {
    return new SendAssignmentOpportunitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendAssignmentOpportunitiesResponse {
    return new SendAssignmentOpportunitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendAssignmentOpportunitiesResponse | PlainMessage<SendAssignmentOpportunitiesResponse> | undefined, b: SendAssignmentOpportunitiesResponse | PlainMessage<SendAssignmentOpportunitiesResponse> | undefined): boolean {
    return proto3.util.equals(SendAssignmentOpportunitiesResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateSubmissionRequest
 */
export class UpdateSubmissionRequest extends Message<UpdateSubmissionRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string updatedPipelineStatus = 2;
   */
  updatedPipelineStatus = "";

  /**
   * @generated from field: bool shouldUpdateMetadata = 3;
   */
  shouldUpdateMetadata = false;

  /**
   * @generated from field: protogen.EntityMetadata updatedMetadata = 4;
   */
  updatedMetadata?: EntityMetadata;

  /**
   * When status is updated to matchmaking we need to update the membership.
   *
   * @generated from field: protogen.Membership updatedMembership = 5;
   */
  updatedMembership?: Membership;

  constructor(data?: PartialMessage<UpdateSubmissionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateSubmissionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updatedPipelineStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shouldUpdateMetadata", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "updatedMetadata", kind: "message", T: EntityMetadata },
    { no: 5, name: "updatedMembership", kind: "message", T: Membership },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSubmissionRequest {
    return new UpdateSubmissionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSubmissionRequest {
    return new UpdateSubmissionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSubmissionRequest {
    return new UpdateSubmissionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSubmissionRequest | PlainMessage<UpdateSubmissionRequest> | undefined, b: UpdateSubmissionRequest | PlainMessage<UpdateSubmissionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSubmissionRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateSubmissionResponse
 */
export class UpdateSubmissionResponse extends Message<UpdateSubmissionResponse> {
  /**
   * @generated from field: protogen.SignupSubmission submission = 1;
   */
  submission?: SignupSubmission;

  constructor(data?: PartialMessage<UpdateSubmissionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateSubmissionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submission", kind: "message", T: SignupSubmission },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSubmissionResponse {
    return new UpdateSubmissionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSubmissionResponse {
    return new UpdateSubmissionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSubmissionResponse {
    return new UpdateSubmissionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSubmissionResponse | PlainMessage<UpdateSubmissionResponse> | undefined, b: UpdateSubmissionResponse | PlainMessage<UpdateSubmissionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSubmissionResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetSignupPaymentLinkRequest
 */
export class GetSignupPaymentLinkRequest extends Message<GetSignupPaymentLinkRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  constructor(data?: PartialMessage<GetSignupPaymentLinkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSignupPaymentLinkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSignupPaymentLinkRequest {
    return new GetSignupPaymentLinkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSignupPaymentLinkRequest {
    return new GetSignupPaymentLinkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSignupPaymentLinkRequest {
    return new GetSignupPaymentLinkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSignupPaymentLinkRequest | PlainMessage<GetSignupPaymentLinkRequest> | undefined, b: GetSignupPaymentLinkRequest | PlainMessage<GetSignupPaymentLinkRequest> | undefined): boolean {
    return proto3.util.equals(GetSignupPaymentLinkRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetSignupPaymentLinkResponse
 */
export class GetSignupPaymentLinkResponse extends Message<GetSignupPaymentLinkResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<GetSignupPaymentLinkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetSignupPaymentLinkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSignupPaymentLinkResponse {
    return new GetSignupPaymentLinkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSignupPaymentLinkResponse {
    return new GetSignupPaymentLinkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSignupPaymentLinkResponse {
    return new GetSignupPaymentLinkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSignupPaymentLinkResponse | PlainMessage<GetSignupPaymentLinkResponse> | undefined, b: GetSignupPaymentLinkResponse | PlainMessage<GetSignupPaymentLinkResponse> | undefined): boolean {
    return proto3.util.equals(GetSignupPaymentLinkResponse, a, b);
  }
}

/**
 * @generated from message protogen.RespondToAssignmentRequest
 */
export class RespondToAssignmentRequest extends Message<RespondToAssignmentRequest> {
  /**
   * @generated from field: string assignmentRef = 1;
   */
  assignmentRef = "";

  /**
   * @generated from field: string responseStatus = 2;
   */
  responseStatus = "";

  /**
   * @generated from field: string declinedReason = 3;
   */
  declinedReason = "";

  constructor(data?: PartialMessage<RespondToAssignmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RespondToAssignmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignmentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "responseStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "declinedReason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RespondToAssignmentRequest {
    return new RespondToAssignmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RespondToAssignmentRequest {
    return new RespondToAssignmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RespondToAssignmentRequest {
    return new RespondToAssignmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RespondToAssignmentRequest | PlainMessage<RespondToAssignmentRequest> | undefined, b: RespondToAssignmentRequest | PlainMessage<RespondToAssignmentRequest> | undefined): boolean {
    return proto3.util.equals(RespondToAssignmentRequest, a, b);
  }
}

/**
 * @generated from message protogen.RespondToAssignmentResponse
 */
export class RespondToAssignmentResponse extends Message<RespondToAssignmentResponse> {
  /**
   * @generated from field: protogen.AssignmentOpportunity assignment = 1;
   */
  assignment?: AssignmentOpportunity;

  constructor(data?: PartialMessage<RespondToAssignmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RespondToAssignmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignment", kind: "message", T: AssignmentOpportunity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RespondToAssignmentResponse {
    return new RespondToAssignmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RespondToAssignmentResponse {
    return new RespondToAssignmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RespondToAssignmentResponse {
    return new RespondToAssignmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RespondToAssignmentResponse | PlainMessage<RespondToAssignmentResponse> | undefined, b: RespondToAssignmentResponse | PlainMessage<RespondToAssignmentResponse> | undefined): boolean {
    return proto3.util.equals(RespondToAssignmentResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAssignmentCandidatesRequest
 */
export class ListAssignmentCandidatesRequest extends Message<ListAssignmentCandidatesRequest> {
  /**
   * One of leadRef or familyRef must be provided.
   *
   * @generated from field: string leadRef = 1;
   */
  leadRef = "";

  /**
   * @generated from field: string familyRef = 2;
   */
  familyRef = "";

  /**
   * @generated from field: bool sortByDistance = 3;
   */
  sortByDistance = false;

  /**
   * @generated from field: bool includeMMForm = 4;
   */
  includeMMForm = false;

  constructor(data?: PartialMessage<ListAssignmentCandidatesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAssignmentCandidatesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "leadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sortByDistance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "includeMMForm", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAssignmentCandidatesRequest {
    return new ListAssignmentCandidatesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAssignmentCandidatesRequest {
    return new ListAssignmentCandidatesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAssignmentCandidatesRequest {
    return new ListAssignmentCandidatesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAssignmentCandidatesRequest | PlainMessage<ListAssignmentCandidatesRequest> | undefined, b: ListAssignmentCandidatesRequest | PlainMessage<ListAssignmentCandidatesRequest> | undefined): boolean {
    return proto3.util.equals(ListAssignmentCandidatesRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAssignmentCandidatesResponse
 */
export class ListAssignmentCandidatesResponse extends Message<ListAssignmentCandidatesResponse> {
  /**
   * @generated from field: repeated protogen.AssignmentCandidate candidates = 1;
   */
  candidates: AssignmentCandidate[] = [];

  constructor(data?: PartialMessage<ListAssignmentCandidatesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAssignmentCandidatesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "candidates", kind: "message", T: AssignmentCandidate, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAssignmentCandidatesResponse {
    return new ListAssignmentCandidatesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAssignmentCandidatesResponse {
    return new ListAssignmentCandidatesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAssignmentCandidatesResponse {
    return new ListAssignmentCandidatesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAssignmentCandidatesResponse | PlainMessage<ListAssignmentCandidatesResponse> | undefined, b: ListAssignmentCandidatesResponse | PlainMessage<ListAssignmentCandidatesResponse> | undefined): boolean {
    return proto3.util.equals(ListAssignmentCandidatesResponse, a, b);
  }
}

/**
 * @generated from message protogen.ExtendAssignmentExpirationRequest
 */
export class ExtendAssignmentExpirationRequest extends Message<ExtendAssignmentExpirationRequest> {
  /**
   * @generated from field: string assignmentRef = 1;
   */
  assignmentRef = "";

  /**
   * @generated from field: int32 minutesToAdd = 2;
   */
  minutesToAdd = 0;

  constructor(data?: PartialMessage<ExtendAssignmentExpirationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ExtendAssignmentExpirationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignmentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "minutesToAdd", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtendAssignmentExpirationRequest {
    return new ExtendAssignmentExpirationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtendAssignmentExpirationRequest {
    return new ExtendAssignmentExpirationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtendAssignmentExpirationRequest {
    return new ExtendAssignmentExpirationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExtendAssignmentExpirationRequest | PlainMessage<ExtendAssignmentExpirationRequest> | undefined, b: ExtendAssignmentExpirationRequest | PlainMessage<ExtendAssignmentExpirationRequest> | undefined): boolean {
    return proto3.util.equals(ExtendAssignmentExpirationRequest, a, b);
  }
}

/**
 * @generated from message protogen.ExtendAssignmentExpirationResponse
 */
export class ExtendAssignmentExpirationResponse extends Message<ExtendAssignmentExpirationResponse> {
  /**
   * @generated from field: protogen.AssignmentOpportunity assignment = 1;
   */
  assignment?: AssignmentOpportunity;

  constructor(data?: PartialMessage<ExtendAssignmentExpirationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ExtendAssignmentExpirationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignment", kind: "message", T: AssignmentOpportunity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtendAssignmentExpirationResponse {
    return new ExtendAssignmentExpirationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtendAssignmentExpirationResponse {
    return new ExtendAssignmentExpirationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtendAssignmentExpirationResponse {
    return new ExtendAssignmentExpirationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExtendAssignmentExpirationResponse | PlainMessage<ExtendAssignmentExpirationResponse> | undefined, b: ExtendAssignmentExpirationResponse | PlainMessage<ExtendAssignmentExpirationResponse> | undefined): boolean {
    return proto3.util.equals(ExtendAssignmentExpirationResponse, a, b);
  }
}

/**
 * @generated from message protogen.ManuallyAssignAdvisorRequest
 */
export class ManuallyAssignAdvisorRequest extends Message<ManuallyAssignAdvisorRequest> {
  /**
   * @generated from field: string submissionRef = 1;
   */
  submissionRef = "";

  /**
   * @generated from field: string advisorRef = 2;
   */
  advisorRef = "";

  constructor(data?: PartialMessage<ManuallyAssignAdvisorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ManuallyAssignAdvisorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submissionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ManuallyAssignAdvisorRequest {
    return new ManuallyAssignAdvisorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ManuallyAssignAdvisorRequest {
    return new ManuallyAssignAdvisorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ManuallyAssignAdvisorRequest {
    return new ManuallyAssignAdvisorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ManuallyAssignAdvisorRequest | PlainMessage<ManuallyAssignAdvisorRequest> | undefined, b: ManuallyAssignAdvisorRequest | PlainMessage<ManuallyAssignAdvisorRequest> | undefined): boolean {
    return proto3.util.equals(ManuallyAssignAdvisorRequest, a, b);
  }
}

/**
 * @generated from message protogen.ManuallyAssignAdvisorResponse
 */
export class ManuallyAssignAdvisorResponse extends Message<ManuallyAssignAdvisorResponse> {
  /**
   * @generated from field: protogen.SignupSubmission submission = 1;
   */
  submission?: SignupSubmission;

  /**
   * @generated from field: protogen.FamilyStub family = 2;
   */
  family?: FamilyStub;

  constructor(data?: PartialMessage<ManuallyAssignAdvisorResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ManuallyAssignAdvisorResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submission", kind: "message", T: SignupSubmission },
    { no: 2, name: "family", kind: "message", T: FamilyStub },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ManuallyAssignAdvisorResponse {
    return new ManuallyAssignAdvisorResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ManuallyAssignAdvisorResponse {
    return new ManuallyAssignAdvisorResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ManuallyAssignAdvisorResponse {
    return new ManuallyAssignAdvisorResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ManuallyAssignAdvisorResponse | PlainMessage<ManuallyAssignAdvisorResponse> | undefined, b: ManuallyAssignAdvisorResponse | PlainMessage<ManuallyAssignAdvisorResponse> | undefined): boolean {
    return proto3.util.equals(ManuallyAssignAdvisorResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetCheckoutSessionRequest
 */
export class GetCheckoutSessionRequest extends Message<GetCheckoutSessionRequest> {
  /**
   * @generated from field: string productName = 2;
   */
  productName = "";

  /**
   * @generated from field: int32 priceAmountCents = 3;
   */
  priceAmountCents = 0;

  /**
   * @generated from field: int32 supportHours = 4;
   */
  supportHours = 0;

  /**
   * @generated from field: int32 maxUsers = 5;
   */
  maxUsers = 0;

  constructor(data?: PartialMessage<GetCheckoutSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetCheckoutSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "productName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "priceAmountCents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "supportHours", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "maxUsers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCheckoutSessionRequest {
    return new GetCheckoutSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCheckoutSessionRequest {
    return new GetCheckoutSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCheckoutSessionRequest {
    return new GetCheckoutSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCheckoutSessionRequest | PlainMessage<GetCheckoutSessionRequest> | undefined, b: GetCheckoutSessionRequest | PlainMessage<GetCheckoutSessionRequest> | undefined): boolean {
    return proto3.util.equals(GetCheckoutSessionRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetCheckoutSessionResponse
 */
export class GetCheckoutSessionResponse extends Message<GetCheckoutSessionResponse> {
  /**
   * @generated from field: protogen.SignupState state = 1;
   */
  state?: SignupState;

  constructor(data?: PartialMessage<GetCheckoutSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetCheckoutSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "message", T: SignupState },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCheckoutSessionResponse {
    return new GetCheckoutSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCheckoutSessionResponse {
    return new GetCheckoutSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCheckoutSessionResponse {
    return new GetCheckoutSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCheckoutSessionResponse | PlainMessage<GetCheckoutSessionResponse> | undefined, b: GetCheckoutSessionResponse | PlainMessage<GetCheckoutSessionResponse> | undefined): boolean {
    return proto3.util.equals(GetCheckoutSessionResponse, a, b);
  }
}

/**
 * @generated from message protogen.ResolveExistingAccountConflictRequest
 */
export class ResolveExistingAccountConflictRequest extends Message<ResolveExistingAccountConflictRequest> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<ResolveExistingAccountConflictRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ResolveExistingAccountConflictRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResolveExistingAccountConflictRequest {
    return new ResolveExistingAccountConflictRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResolveExistingAccountConflictRequest {
    return new ResolveExistingAccountConflictRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResolveExistingAccountConflictRequest {
    return new ResolveExistingAccountConflictRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ResolveExistingAccountConflictRequest | PlainMessage<ResolveExistingAccountConflictRequest> | undefined, b: ResolveExistingAccountConflictRequest | PlainMessage<ResolveExistingAccountConflictRequest> | undefined): boolean {
    return proto3.util.equals(ResolveExistingAccountConflictRequest, a, b);
  }
}

/**
 * @generated from message protogen.ResolveExistingAccountConflictResponse
 */
export class ResolveExistingAccountConflictResponse extends Message<ResolveExistingAccountConflictResponse> {
  /**
   * @generated from field: string resumePhone = 1;
   */
  resumePhone = "";

  /**
   * @generated from field: string signupToken = 2;
   */
  signupToken = "";

  /**
   * @generated from field: string resumeEmail = 3;
   */
  resumeEmail = "";

  constructor(data?: PartialMessage<ResolveExistingAccountConflictResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ResolveExistingAccountConflictResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resumePhone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signupToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resumeEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResolveExistingAccountConflictResponse {
    return new ResolveExistingAccountConflictResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResolveExistingAccountConflictResponse {
    return new ResolveExistingAccountConflictResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResolveExistingAccountConflictResponse {
    return new ResolveExistingAccountConflictResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ResolveExistingAccountConflictResponse | PlainMessage<ResolveExistingAccountConflictResponse> | undefined, b: ResolveExistingAccountConflictResponse | PlainMessage<ResolveExistingAccountConflictResponse> | undefined): boolean {
    return proto3.util.equals(ResolveExistingAccountConflictResponse, a, b);
  }
}

